import React from 'react';
import ReactDOM from 'react-dom/client';



import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";


import reportWebVitals from './reportWebVitals';
import routeConfig from "./route/routeConfig";
import { Helmet } from 'react-helmet';
import { Navigate, Routes, BrowserRouter, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Helmet>
      <title>Gabg Developer</title>
    </Helmet>
    <Routes>
      {routeConfig.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
